import * as Yup from "yup";

// Create Vehicle Yup Schema
export const createVehicleSchema = Yup.object().shape({
  registrationNumber: Yup.string()
    .trim()
    .required("validation:vehicle.licensePlateRequired")
    .min(1, "validation:vehicle.licensePlateMin")
    .max(50, "validation:vehicle.licensePlateMax"),

  type: Yup.mixed<"TRUCK" | "TRAILER">()
    .oneOf(["TRUCK", "TRAILER"], "validation:vehicle.typeInvalid")
    .required("validation:vehicle.typeRequired"),

  displayName: Yup.string()
    .trim()
    .max(100, "validation:vehicle.displayNameMax")
    .nullable(),

  markAndModel: Yup.string()
    .trim()
    .max(200, "validation:vehicle.markModelMax")
    .nullable(),

  weightCapacity: Yup.number()
    .min(0, "validation:vehicle.weightCapacityNegative")
    .typeError("validation:vehicle.weightCapacityNumber")
    .nullable(),

  numberOfAxles: Yup.number()
    .integer("validation:vehicle.axlesInteger")
    .min(1, "validation:vehicle.axlesMin")
    .max(20, "validation:vehicle.axlesMax")
    .typeError("validation:vehicle.axlesNumber")
    .nullable(),

  additionalNotes: Yup.string()
    .trim()
    .max(1000, "validation:vehicle.notesMax")
    .nullable(),
});

// Update Vehicle Yup Schema (all optional)
export const updateVehicleSchema = Yup.object().shape({
  registrationNumber: Yup.string()
    .trim()
    .min(1, "validation:vehicle.licensePlateMin")
    .max(50, "validation:vehicle.licensePlateMax"),

  type: Yup.mixed<"TRUCK" | "TRAILER">().oneOf(
    ["TRUCK", "TRAILER"],
    "validation:vehicle.typeInvalid"
  ),

  displayName: Yup.string()
    .trim()
    .max(100, "validation:vehicle.displayNameMax")
    .nullable(),

  markAndModel: Yup.string()
    .trim()
    .max(200, "validation:vehicle.markModelMax")
    .nullable(),

  weightCapacity: Yup.number()
    .min(0, "validation:vehicle.weightCapacityNegative")
    .nullable(),

  numberOfAxles: Yup.number()
    .integer("validation:vehicle.axlesInteger")
    .min(1, "validation:vehicle.axlesMin")
    .max(20, "validation:vehicle.axlesMax")
    .nullable(),

  additionalNotes: Yup.string()
    .trim()
    .max(1000, "validation:vehicle.notesMax")
    .nullable(),
});
